module.exports = __webpack_public_path__ + "static/media/bwTheme-girl.cd39beb8.svg";